export const VOOMA_USER_EMAIL = 'vooma@vooma.ai';

export const FULLSTORY_ORG = 'o-20S0A5-na1';

export const PYLON_HELP_CENTER_URL = 'https://support.vooma.com';

export const DAT_MCI_URL =
  'https://www.dat.com/load-boards/market-condition-index';
